// extracted by mini-css-extract-plugin
module.exports = {"responsive-container":"responsiveContainer_responsive-container__24eAK"};